import { CHANNEL_INFO_SUCCESS, CHANNEL_INFO_FAIL } from "./actionTypes";

import changeKey from "./keyAction";

import yangAxios from "../YangAxios";

export const getChannelInfo = id => {
  return async (dispatch, getStore) => {
    const keys = getStore().apiKey.keys;
    let index = getStore().apiKey.currentKey;
    try {
      let res = await yangAxios(
        `channels?part=snippet,statistics&id=${id}&key=${keys[index]}`
      );
      res = res.data.items[0];
      const data = {};
      data.subscribers = res.statistics.subscriberCount;
      data.profilePic = res.snippet.thumbnails.medium.url;
      dispatch(getChannelInfoSuccess(data));
    } catch (err) {
      console.log(err);
      if (index < keys.length && err.response && err.response.status === 403) {
        index++;
        dispatch(changeKey(index));
        dispatch(getChannelInfo(id));
        return;
      }
      const error = (err.response && err.response.err) || "Network Error";
      dispatch(getChannelInfoFail(error));
    }
  };
};

const getChannelInfoSuccess = data => {
  return {
    type: CHANNEL_INFO_SUCCESS,
    payload: data
  };
};
const getChannelInfoFail = error => {
  return {
    type: CHANNEL_INFO_FAIL,
    payload: error
  };
};
